import React, {useContext} from "react"

export const ScreenContext = React.createContext<string>("")

export function useScreenContext(): string {
  return useContext(ScreenContext)
}
